// =============================================
// COMPONENTE: NOTIFICATION NODE
// =============================================
// Arquivo: NotificationNode.tsx
// Descrição: Nó para envio de notificações
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { AlertCircle } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const NotificationNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, type, recipient, title, message, description, actions } = data;

  const getTypeLabel = (t: string) => {
    const labels: Record<string, string> = {
      push: 'Push',
      email: 'Email',
      sms: 'SMS'
    };
    return labels[t] || t;
  };

  return (
    <div className={`flow-node notification-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header notification-header">
        <AlertCircle className="node-icon" size={18} />
        <span className="node-title">{label || 'Notificação'}</span>
      </div>

      <div className="node-body">
        {type && (
          <div className="node-field">
            <span className="field-label">Tipo:</span>
            <span className="field-value">{getTypeLabel(type)}</span>
          </div>
        )}
        {recipient && (
          <div className="node-field">
            <span className="field-label">Destinatário:</span>
            <span className="field-value code">{recipient}</span>
          </div>
        )}
        {title && (
          <div className="node-field">
            <span className="field-label">Título:</span>
            <span className="field-value">{title}</span>
          </div>
        )}
        {message && message.length > 50 && (
          <div className="node-field">
            <span className="field-label">Mensagem:</span>
            <span className="field-value truncate">{message.substring(0, 50)}...</span>
          </div>
        )}
        {message && message.length <= 50 && (
          <div className="node-field">
            <span className="field-label">Mensagem:</span>
            <span className="field-value">{message}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default NotificationNode;
